import { useSyncExternalStore } from 'react';
import { WIDE_SCREEN } from './styled';

const query = () => window.matchMedia(WIDE_SCREEN);
const subscribe = (listener) => {
  const media = query();
  media.addEventListener('change', listener);
  return () => media.removeEventListener('change', listener);
};

/** Whether the game screen has its wide layout now (WIDE_SCREEN), following the window as it's resized or turned. */
export default function useWideScreen() {
  return useSyncExternalStore(subscribe, () => query().matches);
}
